import { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import SEO from '@/components/feature/SEO';
import { passportBaseStages, passportDefault, passportProfiles } from '@/mocks/trace-passport';
import PassportHeader from './components/PassportHeader';
import PassportVerifyCard from './components/PassportVerifyCard';
import PassportStageList from './components/PassportStageList';
import PassportActionBar from './components/PassportActionBar';

export default function TracePassport() {
  const [searchParams] = useSearchParams();
  const code = (searchParams.get('code') || '').trim();
  const profile =
    passportProfiles.find((p) => p.code.toUpperCase() === code.toUpperCase()) ?? passportDefault;

  // 首个阶段卡展示本次扫描批次的真实留痕示例
  const stages = passportBaseStages.map((stage, index) =>
    index === 0 ? { ...stage, sample: profile.sample } : stage
  );

  const journeyRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="min-h-screen bg-background-100">
      <SEO
        title={`${profile.product} 溯源数字护照｜来源·检测·流转｜华辉数智`}
        description={`${profile.product}（${profile.origin}）批次溯源数字护照，一物一码。可查看播种投苗建档、种养管理、采摘出栏、检测审核、包装赋码、入仓运输、上架履约到售后召回的全过程留痕记录。`}
        keywords="溯源数字护照,ePin食安码,一物一码,农产品溯源,批次来源,检测流转"
        path="/trace/passport"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: `${profile.product} · 溯源数字护照`,
          description:
            'ePin 食安码溯源数字护照，展示本批次从生产建档、检测审核、包装赋码、入仓运输、上架履约到售后召回的全过程留痕。',
        }}
      />

      <div className="mx-auto w-full max-w-[480px] min-h-screen bg-background-50 pb-24">
        <PassportHeader />
        <main>
          <PassportVerifyCard
            profile={profile}
            onViewJourney={() =>
              journeyRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          />
          <div ref={journeyRef} className="scroll-mt-16">
            <PassportStageList stages={stages} />
          </div>
        </main>
      </div>

      <PassportActionBar />
    </div>
  );
}